export default {
  title: 'Layout ordine',
  form: {
    show_hero_image_with_offers: {
      label: 'Mostra immagine hero con le offerte',
      description:
        "Per impostazione predefinita, aggiungere un'immagine offerta nasconde l'immagine hero. Abilita questa opzione per mostrarle entrambe.",
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
